module.exports = __webpack_public_path__ + "static/media/32-bnder.d488597a.mp3";